export default __webpack_public_path__ + "static/ctaModule_table_tablet-7e13d2ed1f8c2cd65b7086e1440a9d42.png";